export default {
	state:{
		user:{},
		token:false
	},
	getters:{
		
	},
	mutations:{
		//初始化用戶信息
		initUser(state){
			let user = window.sessionStorage.getItem('user')
			if(user){
				state.user= JSON.parse(user)
				state.token= state.user.token
			}
		},
		//登錄方法
		login(state,user){
			//保存登錄狀態
			state.user = user
			state.token = user.token
			window.sessionStorage.setItem('user',JSON.stringify(state.user))
			window.sessionStorage.setItem('token',state.token)
		},
		//退出登錄
		logout(state){
			//清除狀態
			state.user = {}
			state.token = false
			//清除本地存储
			window.sessionStorage.clear()
		}
	},
	actions:{
		
	}
}